import { useLocale } from '@app/store';
import { useFetchFeedbackFormQuery } from '@pages/api/fetch-feedback-form';
import { useTranslation } from '@utils';
import React from 'react';
import FeedbackSteps from './feedback-steps';
import { useLocaleLabelsLoaded } from './hooks/use-locale-labels-loaded';
import FeedbackShell from './shell/feedback-shell';
import FeedbackErrorScreen from './states/feedback-error-screen';
import FeedbackShimmer from './states/feedback-shimmer';
import FeedbackSwitchingOverlay from './states/feedback-switching-overlay';
import './feedback.scss';

// Public feedback form opened from the BE's signed feedback link
// (`/feedback/signed?credentialId=…&signature=…&requestId=…`).
const Feedback = () => {
  const locale = useLocale();
  useLocaleLabelsLoaded(locale);
  const getTranslation = useTranslation();
  const {
    data: form, isPending, isPlaceholderData, isError, error,
  } = useFetchFeedbackFormQuery(locale);

  if (isPending) return <FeedbackShimmer />;
  if (isError) return <FeedbackErrorScreen error={error} />;

  return (
    <FeedbackShell
      title={form.title || getTranslation('FEEDBACK_FORM_TITLE_LABEL')}
      logoUrl={form.logoUrl}
      brandColor={form.brandColor}
      customFont={form.customFont}
    >
      <FeedbackSwitchingOverlay active={isPlaceholderData}>
        <FeedbackSteps form={form} locale={locale} />
      </FeedbackSwitchingOverlay>
    </FeedbackShell>
  );
};

export default Feedback;
